/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  EuiFlexGroup,
  EuiHorizontalRule,
  EuiModal,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
} from "@inscopix/ideas-eui";
import { ModelSchema } from "api/client/types/DjangoClient.types";
import { WorkflowEditorTimeline } from "./WorkflowEditorForm/WorkflowEditorTimeline/WorkflowEditorTimeline";
import { WorkflowEditorProvider } from "./WorkflowEditorProvider/WorkflowEditorProvider";
import { WorkflowEditorPages } from "./WorkflowEditorForm/pages/WorkflowEditorPages";
import { WorkflowEditorBottomBar } from "./WorkflowEditorForm/WorkflowEditorBottomBar";

export interface ModalCreateWorkflowProps {
  analysisTableIds: ModelSchema["GdtAnalysisTableSchema"]["id"][];
  onClose: () => void;
}

export const ModalCreateWorkflow = ({
  analysisTableIds,
  onClose,
}: ModalCreateWorkflowProps) => {
  return (
    <WorkflowEditorProvider analysisTableIds={analysisTableIds}>
      <EuiModal
        onClose={onClose}
        css={css`
          width: 90vw;
          height: 90vh;
          max-width: 90vw;
          display: flex;
          flex-direction: column;
        `}
      >
        <EuiModalHeader>
          <EuiFlexGroup direction="column" gutterSize="none">
            <EuiModalHeaderTitle component="h3">
              Create Workflow
            </EuiModalHeaderTitle>

            <WorkflowEditorTimeline />

            <EuiHorizontalRule margin="none" />
          </EuiFlexGroup>
        </EuiModalHeader>

        <WorkflowEditorPages />
        <EuiModalFooter>
          <WorkflowEditorBottomBar />
        </EuiModalFooter>
      </EuiModal>
    </WorkflowEditorProvider>
  );
};
